webpackJsonp([265829349824568],{

/***/ 2033:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StripeCustomer","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"email","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"invoiceSettings","type":{"kind":"OBJECT","name":"StripeInvoiceSettings","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-stripe-customer-be569f2066f8287fa7de.js